import type { IGetActionsData } from "@api";
import type { ObjectId } from "@bbj-types/utils";
import { toStartOfDay } from "@root/utils/date/toStartOfDay";
import { addDays, addMinutes } from "date-fns";

export interface ISlotConflictInput {
  date: Date;
  startTime: number;
  timeZone: string;
  currentActionId?: ObjectId;
}

// findActions paginates with a small default limit; a day of one candidate never comes close to this cap.
const SLOT_DAY_ACTIONS_LIMIT = 100;

export const getSlotDayRange = (date: Date, timeZone: string) => {
  const dayStart = toStartOfDay(date, timeZone);
  return { startDate: dayStart, endDate: addDays(dayStart, 1), limit: SLOT_DAY_ACTIONS_LIMIT, active: true };
};

export const getSlotDate = (date: Date, startTime: number, timeZone: string) =>
  addMinutes(toStartOfDay(date, timeZone), startTime);

// An action conflicts when another action of the candidate starts at the exact same minute.
export const hasSlotConflict = (
  actions: Pick<IGetActionsData, "_id" | "executionDate" | "date">[],
  { date, startTime, timeZone, currentActionId }: ISlotConflictInput
): boolean => {
  const slotTime = getSlotDate(date, startTime, timeZone).getTime();
  return actions.some((action) => {
    if (currentActionId && action._id === currentActionId) {
      return false;
    }
    const actionDate = action.executionDate ?? action.date;
    return actionDate !== undefined && new Date(actionDate).getTime() === slotTime;
  });
};
